module.exports = __webpack_public_path__ + "static/media/maintenance3.4370c18b.jpg";